import { AxiosResponse } from 'axios';
import { SchemaPipeline } from '@src/types/generated/api';
import { httpExt } from './base-http-external';

export function getPipelineExternalApi(
  pipelineName: string,
  workspaceName?: string,
): Promise<AxiosResponse<SchemaPipeline>> {
  return httpExt.get(`/api/v1/workspaces/${workspaceName}/pipelines/${pipelineName}`);
}

export function activatePipelineExternalApi(pipelineName: string, workspaceName?: string) {
  return httpExt.post(`/api/v1/workspaces/${workspaceName}/pipelines/${pipelineName}/activate`);
}
